import React, { Component } from 'react'
import PropTypes from 'prop-types'
import showDateTime from "../../shared/ShowDateTime"
import classNames from "classnames"
import BatchPartnerInfo from "./partner/BatchPartnerInfo"
import SewingPartner from "./sewing-partner/SewingPartner"
import UserCreate from "./UserCreate";
import { Modal, Table, Tooltip } from 'antd'
import BatchNote from './BatchNote'

class BatchInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
        }
    }

    showModal = () => {
        this.setState({ isModalOpen: true })
    }
    handleCancel = () => {
        this.setState({ isModalOpen: false })
    }
    render() {
        const { batch, error, refreshBatchInfo } = this.props
        const { status, created_at, product_types, preference, statistic_quantity, tags = [], location = '', metadata = {} } = { ...batch }
        const { type, w, h, is_enable } = { ...metadata.frame }
        const isCutOff = Array.isArray(tags) && tags.includes('cutoff')
        const isCutOffNoel = Array.isArray(tags) && tags.includes('cutoff_noel')
        const isCutOffNewYear = Array.isArray(tags) && tags.includes('cutoff_new_year')

        const locationName = location === "MC" ? "MC Lab" : ''

        const color = classNames({
            'pending progress-bar-animated progress-bar-striped': status === 'pending' || status === 'processing',
            'printing progress-bar-animated progress-bar-striped': status === 'printing',
            'printed': status === 'printed',
            'transferring progress-bar-animated progress-bar-striped': status === 'transferring',
            'transferred': status === 'transferred',
            'confirmed': status === 'confirmed',
            'wait-sew progress-bar-animated progress-bar-striped': status === 'wait_to_sew',
            'sewing': status === 'sewing',
            'completed': status === 'completed' || status === 'done',
        })

        const columns = [
            {
                title: 'Type',
                dataIndex: 'type',
                key: 'type',
            },
            {
                title: 'Size',
                dataIndex: 'size',
                key: 'size',
            },
            {
                title: 'Số lượng',
                dataIndex: 'quantity',
                key: 'quantity',
            },
        ];

        const types = {
            area: 'Khổ nguyên vật liệu',
            quantity: 'Lưới',
        }

        return (
            <div className="BatchInfo">
                {
                    !error ?
                        <div className='jumbotron p-3 mb-3'>
                            <div className="d-flex align-items-center mb-3">
                                <h3 className="mb-0">Tên lô: <strong>{batch.name}</strong></h3>
                                <div className="Status ml-2 d-flex align-items-center justify-content-between">
                                    <span className={`badge ${color || status} badge-pill`}>{status}</span>
                                    {isCutOff && <span className={`badge badge-pill ml-2`} style={{ background: "#FF6600", color: "white" }}>cutoff</span>}
                                    {isCutOffNoel && <span className={`badge badge-pill ml-2`} style={{ background: "#FF6600", color: "white" }}>cutoff_noel</span>}
                                    {isCutOffNewYear && <span className={`badge badge-pill ml-2`} style={{ background: "#FF6600", color: "white" }}>cutoff_new_year</span>}
                                    <i className="fa fa-info-circle ml-2 cursor-pointer" style={{ fontSize: 20 }} onClick={this.showModal} />
                                </div>
                                <Modal title="Info item" visible={this.state.isModalOpen} onCancel={this.handleCancel} footer={null}>
                                    <Table
                                        dataSource={statistic_quantity}
                                        columns={columns}
                                        pagination={{ defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ['10', '20', '30'] }}
                                        style={{ width: '100%', maxHeight: 500, overflowY: 'auto', overflowX: 'hidden' }}
                                    />
                                </Modal>
                            </div>
                            <div><h6>Ngày tạo: <strong>{showDateTime(created_at)}</strong></h6></div>
                            {/*<div><h6>Người tạo: <strong>{batch.user_create}</strong></h6></div>*/}
                            <UserCreate
                                userCreate={batch.user_create}
                                batchId={batch._id}
                                status={status}
                                refreshBatchInfo={refreshBatchInfo}
                            />
                            {
                                (product_types.length === 1 && !!preference && !!preference.sku) && (
                                    <>
                                        <div><h6>Nguyên vật
                                            liệu: <strong>{!!preference.sku.materials ? preference.sku.materials : ''}</strong>
                                            {!!type &&
                                                <>
                                                    <strong className='mx-1' style={{ fontSize: 20 }}>|</strong>
                                                    <Tooltip title={`${(!!w || w === 0) ? 'Width' : ''}${((!!w || w === 0) && (!!h || h === 0)) ? ' x ' : ''}${(!!h || h === 0) ? 'Height' : ''}`}>
                                                        <strong style={{ fontSize: 20, color: '#ff3b30' }}>
                                                            {`${(!!w || w === 0) ? w : ''}${((!!w || w === 0) && (!!h || h === 0)) ? ' x ' : ''}${(!!h || h === 0) ? h : ''}`}
                                                            {type === 'area' && ' (cm)'}
                                                        </strong>
                                                    </Tooltip>
                                                </>
                                            }
                                        </h6>
                                        </div>
                                        <div><h6>Mô
                                            tả: <strong className='text-break' style={{ whiteSpace: 'pre-line' }}>{!!preference.sku.description ? preference.sku.description.replace(/\\n/g, '\n') : ''}</strong>
                                        </h6>
                                        </div>
                                    </>
                                )
                            }
                            {/* <div><h6>Ghi chú: <small>{batch.note}</small></h6></div> */}
                            <BatchNote
                                note={batch.note}
                                batchId={batch._id}
                                refreshBatchInfo={refreshBatchInfo}
                            />

                            {
                                batch.hasOwnProperty('partner') &&
                                <BatchPartnerInfo
                                    partner={batch.partner}
                                    batchId={batch._id}
                                    status={status}
                                    refreshBatchInfo={refreshBatchInfo}
                                />
                            }

                            {
                                batch.hasOwnProperty('sewing_partner') &&
                                <SewingPartner
                                    partner={batch.sewing_partner}
                                    batchId={batch._id}
                                    receiveSewName={batch.receive_sew_name}
                                    receiveSewAt={batch.receive_sew_at}
                                    status={status}
                                    refreshBatchInfo={refreshBatchInfo}
                                />
                            }

                            {
                                !!locationName &&
                                <div><h6>Địa điểm sản xuất: <strong>{locationName}</strong></h6></div>
                            }
                        </div>
                        : <div className='mb-3 text-danger'>{error}</div>
                }
            </div>
        )
    }
}

BatchInfo.propTypes = {
    batch: PropTypes.object.isRequired,
    error: PropTypes.string,
    refreshBatchInfo: PropTypes.func.isRequired

}

export default BatchInfo
